/** Mini-Balken-Sparkline (Flugdauern) für Watchlist-Cards. */
export default function Sparkline({ values }: { values: number[] }) {
  if (values.length === 0) return null;
  const w = 64;
  const h = 14;
  const max = Math.max(...values, 1);
  const barW = w / Math.max(values.length, 8);
  return (
    <svg className="sparkline" width={w} height={h} aria-label="Letzte Flüge">
      {values.map((v, i) => {
        const barH = Math.max((v / max) * h, 1.5);
        return (
          <rect
            key={i}
            x={i * barW + 0.5}
            y={h - barH}
            width={barW - 1}
            height={barH}
            rx={0.5}
          />
        );
      })}
    </svg>
  );
}
